import React from 'react';
import { Flex } from '@chakra-ui/react';
import MemberHeroSection from '@/components/membership/MemberHeroSection';
import MembersTab from '@/components/membership/MembersTab';

const membersHeroData = {
  title: 'Our Members',
  desc: 'IVCA members are the most active domestic and global VCs, PEs, funds for Infrastructure, Real Estate, Credit funds, Limited Partners, Investment Companies, Family offices, Corporate VCs and Knowledge Partners. These  funds invest into emerging companies, venture growth, buyout, special  situations, distressed assets, credit & venture debt among others.',
};

const MembersLayout: React.FC = () => (
  <Flex as="section" flexDir="column">
    <MemberHeroSection
      title={membersHeroData.title}
      desc={membersHeroData.desc}
      type="membership"
    />
    <MembersTab />
  </Flex>
);

export default MembersLayout;
